import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { Box, FormControl } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { OverLabel, RawControlInput, FieldWrapper, ErrorText } from './styles';

export default function Field({
  label,
  defaultValue,
  onFocus,
  focus,
  name,
  disabled = false,
  ...props
}) {
  const { t } = useTranslation();
  const {
    formState: { errors },
    watch,
  } = useFormContext();
  
  const inputValue = watch(name, defaultValue);
  const hasError = !!errors?.[name];

  return (
    <FieldWrapper {...props}>
      <FormControl error={hasError} sx={{ width: '100%', background: 'transparent' }}>
        <Box sx={{ position: 'relative', display: 'flex' }}>
          {!inputValue && (
            <OverLabel isaside={focus || inputValue?.length ? 1 : 0}>
              {label}
            </OverLabel>
          )}
          <Controller
            defaultValue={defaultValue}
            name={name}
            render={({ field: { value, onChange, ...fieldProps } }) => (
              <RawControlInput
                {...fieldProps}
                value={value || ''}
                onChange={onChange}
                focus={+focus}
                autoComplete="off"
                onFocus={onFocus}
                error={hasError}
                disabled={disabled}
              />
            )}
          />
        </Box>
      </FormControl>
      <ErrorText>
        {hasError ? t(errors[name].message) : ' '}
      </ErrorText>
    </FieldWrapper>
  );
}
